/**
 * Utility to prevent and fix iOS zoom issues
 */

/**
 * Resets the viewport zoom to 1.0 scale
 * Useful when iOS zoom persists after closing dialogs
 */
export const resetZoom = () => {
  if (typeof window === 'undefined') return;

  // Force viewport reset
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    const content = viewport.getAttribute('content');
    if (content) {
      // Temporarily change and then restore to force a reset
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
      setTimeout(() => {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
      }, 10);
    }
  }

  // Also try to scroll to top which can help reset zoom
  window.scrollTo(0, 0);
};

/**
 * Hook to automatically reset zoom when a condition changes (e.g., dialog closes)
 */
export const useZoomReset = (shouldReset: boolean) => {
  if (typeof window === 'undefined') return;

  if (shouldReset) {
    // Small delay to ensure dialog is fully closed
    setTimeout(() => {
      resetZoom();
    }, 100);
  }
};
